/// <reference path="../../../../../typings/index.d.ts" />
/// <reference path="../../../components/models/meevo.model.custom.ts" />



module Meevo.Plugins.PurchaseOrder{
    enum QuantityTypeEnum {
        QtyOrdered,
        Received,
        ReceivedToday
    }
    import ProductInventoryTypeEnum = Meevo.Model.ProductInventoryTypeEnum;
    import PurchaseOrderDetails = Meevo.Model.PurchaseOrderDetails;
    import PurchaseOrderStateEnum = Meevo.Model.PurchaseOrderStateEnum;

    export class PrintPoModalController implements ng.IComponentController {

        static $inject = [ //update here names defined in modal options
            'product',
            'receivals',
            'callback',
            '$translate',
            '$timeout',
            'meevo.components.modal.ModalService'
        ];

        public isAllSelected: boolean = false;
        public qtyOfLabelAmountList: any[];
        public qtyType: QuantityTypeEnum = QuantityTypeEnum.ReceivedToday;
        public prevQtyType: QuantityTypeEnum = this.qtyType;
        public showInventoryTypeToggleButtons: boolean = false;

        constructor( //parameters here
            protected purchaseOrder: Model.PurchaseOrder,
            protected receivals: Model.PurchaseOrderReceival,
            private callback: Function,
            private $translate: angular.translate.ITranslateService,
            private $timeout: angular.ITimeoutService,
            private modalService: Meevo.Components.Modal.IModalService
        ) {
            this.qtyOfLabelAmountList = [];
            this.qtyOfLabelAmountList.push({ "key": QuantityTypeEnum.QtyOrdered, "value": "LABEL_QUANTITY_ORDERED" });
            this.qtyOfLabelAmountList.push({ "key": QuantityTypeEnum.Received, "value": "LABEL_PO_RECEVEID" });
            this.qtyOfLabelAmountList.push({ "key": QuantityTypeEnum.ReceivedToday, "value": "LABEL_PO_RECEVEID_TODAY" });

            //this.purchaseOrder.lineItems.forEach(pv => pv.orderQuantity = pv.onHand);
            this.purchaseOrder.lineItems.forEach(pv => {
                var receivedLineItem = this.receivals.receivalLineItems.find((rv, ndx, arr) =>
                { return rv.variantId == pv.id && rv.productInventoryType == pv.productInventoryType && rv.orderOfEntry == pv.orderOfEntry; });
                if (receivedLineItem) {
                    pv["receivedQuantity"] = receivedLineItem.receiveQuantity;
                    pv["receivedToday"] = receivedLineItem["receivedToday"] || 0;
                }
            });

            if (this.purchaseOrder && this.purchaseOrder.purchaseOrderState == PurchaseOrderStateEnum.NotReceived) {
                this.qtyType = QuantityTypeEnum.QtyOrdered;
            }
            this.setNumberOfLabelsToSelectedQuantityType();
        }

        $onInit() {
            setTimeout(() => {
                this.showInventoryTypeToggleButtons = this.purchaseOrder.productInventoryType == ProductInventoryTypeEnum.RetailOrShopSupply;
                if (this.showInventoryTypeToggleButtons) {
                    for (let index = 0; index < this.purchaseOrder.lineItems.length; index++) {
                        let item = this.purchaseOrder.lineItems[index];
                        item.isSelected = item.productInventoryType == ProductInventoryTypeEnum.Retail;
                    }
                }
            });
            this.isAllSelected = this.checkIsAllSelected();
        }

        toggleRetailButtonClicked() : void {
            const isSelected = !this.areAllRetailItemsSelected;
            this.purchaseOrder.lineItems.forEach((item) => {
                if (item.productInventoryType == ProductInventoryTypeEnum.Retail) {
                    item.isSelected = isSelected;
                }    
            });
            this.setIsAllSelected();
        }

        toggleShopSupplyButtonClicked() : void {
            const isSelected = !this.areAllShopSupplyItemsSelected;
            this.purchaseOrder.lineItems.forEach((item) => {
                if (item.productInventoryType == ProductInventoryTypeEnum.ShopSupply) {
                    item.isSelected = isSelected;
                }    
            });
            this.setIsAllSelected();
        }

        get areAllRetailItemsSelected() : boolean {
            return this.retailLineItems.every(x => x.isSelected);
        }

        get areAllShopSupplyItemsSelected() : boolean {
            return this.shopSupplyLineItems.every(x => x.isSelected);
        }

        get retailToggleButtonText() : string {
            return this.areAllRetailItemsSelected ?
                this.$translate.instant("LABEL_DESELECT_ALL_RETAIL") :
                this.$translate.instant("LABEL_SELECT_ALL_RETAIL");
        }

        get shopSupplyToggleButtonText() : string {
            return this.areAllShopSupplyItemsSelected ?
                this.$translate.instant("LABEL_DESELECT_ALL_SHOP_SUPPLY") :
                this.$translate.instant("LABEL_SELECT_ALL_SHOP_SUPPLY");
        }

        get retailLineItems() : PurchaseOrderDetails[] {
            return this.purchaseOrder.lineItems.filter(x => x.productInventoryType == ProductInventoryTypeEnum.Retail);
        }

        get shopSupplyLineItems() : PurchaseOrderDetails[] {
            return this.purchaseOrder.lineItems.filter(x => x.productInventoryType == ProductInventoryTypeEnum.ShopSupply);
        }

        quantityTypeChanged() {
            if (this.hasNumberOfLabelsChanged()) {
                 this.modalService.yellowConfirm("LABEL_CUSTOM_VALUES_ALERT", Meevo.Components.Modal.ModalTranslationModes.Translate, true, undefined, true)
                    .then((result) => {
                        if (result) {
                            // they selected YES
                            this.setNumberOfLabelsToSelectedQuantityTypeExceptDiff();
                        }
                        else {
                            // they selected NO
                            this.setNumberOfLabelsToSelectedQuantityType();
                        }
                        this.prevQtyType = this.qtyType;
                    });
            }
            else {
                this.setNumberOfLabelsToSelectedQuantityType();
                this.prevQtyType = this.qtyType;
            }
        }

        hasNumberOfLabelsChanged(): boolean {
            var hasChanged = false;
            for (let i = 0; i < this.purchaseOrder.lineItems.length; i++) {
                let thisItem = this.purchaseOrder.lineItems[i];
                if ((this.prevQtyType === QuantityTypeEnum.QtyOrdered && thisItem.numberOfLabels != thisItem.orderQuantity)
                    || (this.prevQtyType === QuantityTypeEnum.Received && thisItem.numberOfLabels != thisItem["receivedQuantity"])
                    || (this.prevQtyType === QuantityTypeEnum.ReceivedToday && thisItem.numberOfLabels != thisItem["receivedToday"])) {
                    hasChanged = true;
                    break;
                }
            }
            return hasChanged;
        }

        setNumberOfLabelsToSelectedQuantityTypeExceptDiff() {
            for (let i = 0; i < this.purchaseOrder.lineItems.length; i++) {
                let thisItem = this.purchaseOrder.lineItems[i];
                if ((this.prevQtyType !== QuantityTypeEnum.QtyOrdered || thisItem.numberOfLabels == thisItem.orderQuantity)
                    && (this.prevQtyType !== QuantityTypeEnum.Received || thisItem.numberOfLabels == thisItem["receivedQuantity"])
                    && (this.prevQtyType !== QuantityTypeEnum.ReceivedToday || thisItem.numberOfLabels == thisItem["receivedToday"])) {
                    // set numberOfLabels to value based on qtyType
                    if (this.qtyType === QuantityTypeEnum.QtyOrdered) {
                        thisItem.numberOfLabels = thisItem.orderQuantity;
                    }
                    else if (this.qtyType === QuantityTypeEnum.Received) {
                        thisItem.numberOfLabels = thisItem["receivedQuantity"];
                    }
                    else /* if (this.qtyType === QuantityTypeEnum.ReceivedToday) */ {
                        thisItem.numberOfLabels = thisItem["receivedToday"];
                    }
                }
            }
        }

        setNumberOfLabelsToSelectedQuantityType() {
            for (let i = 0; i < this.purchaseOrder.lineItems.length; i++) {
                if (this.qtyType === QuantityTypeEnum.QtyOrdered) {
                    this.purchaseOrder.lineItems[i].numberOfLabels = this.purchaseOrder.lineItems[i].orderQuantity;
                }
                else if (this.qtyType === QuantityTypeEnum.Received) {
                    this.purchaseOrder.lineItems[i].numberOfLabels = this.purchaseOrder.lineItems[i]["receivedQuantity"];
                }
                else /* if (this.qtyType === QuantityTypeEnum.ReceivedToday) */ {
                    this.purchaseOrder.lineItems[i].numberOfLabels = this.purchaseOrder.lineItems[i]["receivedToday"];
                }
            }
        }

        //spinner
        compareNumOfLabelsQtyType(item) {
            item.canRevert =
                  ((this.qtyType == QuantityTypeEnum.QtyOrdered    && item.numberOfLabels != item.orderQuantity)
                || (this.qtyType == QuantityTypeEnum.Received      && item.numberOfLabels != item["receivedQuantity"])
                || (this.qtyType == QuantityTypeEnum.ReceivedToday && item.numberOfLabels != item["receivedToday"]));
        }

        revertNumberOfLabels(item) { 
            if (this.qtyType == QuantityTypeEnum.QtyOrdered) {
                item.numberOfLabels = item.orderQuantity;
            } else if (this.qtyType ==QuantityTypeEnum.Received) {
                item.numberOfLabels = item["receivedQuantity"];
            } else /*QuantityTypeEnum.ReceivedToday*/ { 
                item.numberOfLabels = item["receivedToday"];
            }
        }

        styleClass(item) {
            var style = 'revert-ui-border'
            if (
                ((this.qtyType == QuantityTypeEnum.QtyOrdered    && item.numberOfLabels != item.orderQuantity)
              || (this.qtyType == QuantityTypeEnum.Received      && item.numberOfLabels != item["receivedQuantity"])
              || (this.qtyType == QuantityTypeEnum.ReceivedToday && item.numberOfLabels != item["receivedToday"]))) {
                return style;
            }
        }

        revertIcon(item) {
            var display: boolean = true; 
            if (
                ((this.qtyType == QuantityTypeEnum.QtyOrdered    && item.numberOfLabels != item.orderQuantity)
              || (this.qtyType == QuantityTypeEnum.Received      && item.numberOfLabels != item["receivedQuantity"])
              || (this.qtyType == QuantityTypeEnum.ReceivedToday && item.numberOfLabels != item["receivedToday"]))) {
                return display;
            }
        }
        close() {
            this.modalService.hide();
        }
        cancel() {
            this.modalService.hide();
        }
        continue() {
            var items: Model.PurchaseOrderDetails[] = this.purchaseOrder.lineItems.filter(v => v.isSelected && v.orderQuantity > 0);
            // Multiply order qty by multiplesOf when package type is case U.S.55668
            items.forEach(item => {
                if (item.productPackageType == Model.ProductPackageTypeEnum.Case) {
                    item.numberOfLabels = this.getQuantityOfLabels(item);
                }
            })
            this.callback(items);
            this.modalService.hide();
        }

        checkIsAllSelected(): boolean {
            return this.purchaseOrder.lineItems.every((item: any) => item.isSelected);
        }

        selectAll() {
            this.purchaseOrder.lineItems.forEach(item => {
                item.isSelected = this.isAllSelected;;
            });
        }

        checkSelectedItem(item) {
            this.setIsAllSelected();
        }

        setIsAllSelected() : void {
            this.$timeout(() => {
                this.isAllSelected = this.checkIsAllSelected();    
            });
        }

        canPrint(): boolean {
            var allow: boolean = false;
            for (var ndx = 0; ndx < this.purchaseOrder.lineItems.length; ndx++) {
                var obj: Meevo.Model.PurchaseOrderDetails = this.purchaseOrder.lineItems[ndx];
                if (obj.isSelected && obj.numberOfLabels > 0) {
                    allow = true;
                    break;
                }
            }
            return allow;
        }

        getQuantityOfLabels(item: PurchaseOrderDetails): number {
            if (item.productPackageType == Model.ProductPackageTypeEnum.Case) {
                return item.numberOfLabels * item.multiplesOf;
            }
            else {
                return item.numberOfLabels;
            }
        }
    }

    angular.module("meevo.plugins.purchaseOrder")
        .controller("meevo.plugins.purchaseOrder.PrintPoModalController", PrintPoModalController);
}